import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import SetValidationErrors from '@/mixins/SetValidationErrors';
import {AxiosError} from 'axios';
import {debug} from '@/utils/helpers';

@Component
export default class SnackbarMixin extends mixins(SetValidationErrors) {
  handleSuccess(message: string) {
    this.$snackbar.show(message, 'success');
    this.onSuccess(message);
  }

  catchError(e: AxiosError) {
    const message = e.response?.data?.message || e.message;
    this.$snackbar.show(message, 'error');
    this.setValidationErrors(e);
    this.onError(e);
  }

  onSuccess(message?: string) {
    debug(message);
  }

  onError(e?: any) {
    debug(e?.message);
  }
}
